import { useTheme } from '@/shared/hooks/useTheme';
import { publicAssetUrl } from '@/shared/lib/publicAssetUrl';

const lightLogoUrl = publicAssetUrl('sshop-logo-light.png');
const darkLogoUrl = publicAssetUrl('sshop-logo-dark.png');

interface BrandProps {
  readonly className?: string;
  readonly size?: 'sm' | 'md';
}

const SIZE: Record<NonNullable<BrandProps['size']>, string> = {
  sm: 'h-7',
  md: 'h-7 sm:h-9',
};

export function Brand({ className, size = 'md' }: BrandProps) {
  const { resolvedTheme } = useTheme();
  const logoUrl = resolvedTheme === 'dark' ? darkLogoUrl : lightLogoUrl;

  return (
    <span className={['inline-flex items-center', className ?? ''].join(' ')}>
      <img
        src={logoUrl}
        alt="SSHOP"
        className={`${SIZE[size]} w-auto select-none`}
        draggable={false}
        decoding="async"
      />
    </span>
  );
}
